import { useRef, useState } from "react";
import { useInput } from "react-admin";
// @ts-ignore
import "./PhoneInput.scss";
import {
  PhoneInput as InternationalPhoneInput,
  ParsedCountry
} from "react-international-phone";
// @ts-ignore
import "react-international-phone/style.css";
import { isPhoneValid } from "../utils/isPhoneValid";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import { useFormContext } from "react-hook-form";

export const getPhone = (value: string) => {
  if (!value) return "";

  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const numberProto = phoneUtil.parseAndKeepRawInput(value);
    return phoneUtil.format(numberProto, PhoneNumberFormat.INTERNATIONAL);
  } catch (error) {
    return value;
  }
};

const PhoneInput = ({
  source,
  fullWidth,
  checkSubmitted = false,
  onBlur
}: {
  source: string;
  fullWidth?: boolean;
  checkSubmitted?: boolean;
  onBlur?: (value: string) => void;
}) => {
  const form = useFormContext();
  const { field } = useInput({ source });
  const [phone, setPhone] = useState(field.value);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const formValue = form.getFieldState(source ? source : "phone_number");
  const isInvalid = formValue.invalid;

  const [country, setCountry] = useState<ParsedCountry>({
    areaCodes: undefined,
    dialCode: "1",
    format: "(...) ...-....",
    iso2: "us",
    name: "United States",
    priority: 0
  });
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const isValid = isInvalid || !checkSubmitted ? isPhoneValid(phone) : true;

  return (
    <div className="relative w-full">
      <div
        onClick={() => {
          if (inputRef?.current) {
            inputRef?.current.focus();
            inputRef?.current.setSelectionRange(-1, -1);
          }
        }}
        className="absolute top-0 cursor-text left-[58px] 
        w-[calc(100%-58px)] h-[16px] bg-transparent z-50"
        aria-hidden
      />
      <InternationalPhoneInput
        className="phone-input"
        defaultCountry="us"
        value={phone}
        placeholder={(country.format as string) || "Phone number"}
        style={{
          display: "flex",
          width: "100%",
          marginBottom: !isValid ? "0px" : "16px",
          border: !isValid
            ? "1px solid #EF5B1B"
            : isFocused
            ? "1px solid #b8722a"
            : "1px solid rgba(48, 47, 46, 0.1)",
          borderRadius: "8px"
        }}
        onChange={(phone: string, { country, inputValue }) => {
          setPhone(phone);
          setCountry(country);
          field.onChange({ target: { value: inputValue } });
        }}
        inputRef={inputRef}
        inputStyle={{
          outline: "none",
          border: "none",
          fontSize: "1rem",
          lineHeight: "1.5",
          opacity: 1,
          display: "flex",
          flexDirection: "column",
          width: fullWidth ? "100%" : "50%",
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          padding: "1px 12px 4px 12px",
          position: "relative",
          color: !isValid ? "#EF5B1B" : "black"
        }}
        countrySelectorStyleProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            zIndex: 1000,
            color: "black"
          },
          dropdownStyleProps: {
            style: {
              backgroundColor: "rgba(255,255,255, 1)",
              color: "black",
              zIndex: 1000
            }
          }
        }}
        inputProps={{
          onFocus: () => setIsFocused(true),
          onBlur: () => {
            setIsFocused(false);
            onBlur?.(field.value);
          }
        }}
      />
      {!isValid && (
        <span
          style={{
            color: "#EF5B1B",
            fontSize: "0.75rem",
            marginTop: "0.25rem"
          }}
        >
          Wrong phone number format
        </span>
      )}
    </div>
  );
};

export default PhoneInput;
